import React from 'react';
import { ValidationMessage, ValidationMessageProps } from '~/components/Form/ValidationMessage';

interface FormGroupProps {
    htmlFor?: string;
    children?: React.ReactNode;
    className?: string;
    submitted?: boolean;
    validation?: null | {
        invalidRules: string[];
        touched: boolean;
        valid: boolean;
    };
}
function FormGroup({ submitted = false, validation = null, ...props }: FormGroupProps) {
    function validationClasses() {
        const classes = ['', 'zp-form-group'];
        if (validation) {
            if (validation?.touched) {
                classes.push('touched');
            }
            if (validation?.valid) {
                classes.push('valid');
            } else {
                classes.push('invalid');
                validation?.invalidRules.forEach((x) => classes.push(`invalid-${x}`));
            }
        }
        return classes.join(' ');
    }

    function displayChildren(child: React.ReactNode) {
        if (React.isValidElement(child)) {
            React.Children.forEach(child.props.children, (x) => displayChildren(x));
        }
        // On render, pass validation props down to ValidationMessage so that
        // it can modify display classes
        if (React.isValidElement(child) && child.type === ValidationMessage) {
            // eslint-disable-next-line no-param-reassign
            child = React.cloneElement(child as React.ReactElement, {
                submitted,
                valid: validation?.valid, // If you're having issues on this line, make sure you haven't wrapped your conditional field in another element. Each <FormGroup> should be a direct child of the <Form>. If you need to hide/show multiple fields, just handle them separately
                invalidRules: validation?.invalidRules,
                key: (child.props as ValidationMessageProps).type,
            });
        }
        return child;
    }

    return (
        <div className={(props.className || '') + validationClasses()}>
            {React.Children.map(props.children, (x) => displayChildren(x))}
        </div>
    );
}

export { FormGroup };
